// src/redux/inventorysubcategorySlice.js

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  get_inventorysubcategory,
  add_inventorysubcategory,
  update_inventorysubcategory,
  delete_inventorysubcategory,
  get_inventorysubcategory_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
  inventorysubcategory: [],
  inventorysubcategorylist:[],
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    inventorycategory: "",
    size_in:"",
  },
};

// Async Thunks for API Calls
export const fetchinventorysubcategoryList = createAsyncThunk(
    'inventorysubcategory/fetchinventorysubcategorylist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_inventorysubcategory_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  // Async Thunks for API Calls


// Async Thunks for API Calls
export const fetchinventorysubcategory = createAsyncThunk(
  "inventorysubcategory/fetchinventorysubcategory",
  async ({ page, page_size,school_id,search, token, signal }, { rejectWithValue }) => {

    try {
      const response = await get_inventorysubcategory(page, page_size,school_id,search,token, signal);

        
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const createinventorysubcategory = createAsyncThunk(
  "inventorysubcategory/createinventorysubcategory",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_inventorysubcategory(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateinventorysubcategory = createAsyncThunk(
  "inventorysubcategory/updateinventorysubcategory",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_inventorysubcategory(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteinventorysubcategory = createAsyncThunk(
  "inventorysubcategory/deleteinventorysubcategory",
  async ({ ids,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_inventorysubcategory({ ids }, school_id,token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// inventorysubcategory Slice
const inventorysubcategorySlice = createSlice({
  name: 'inventorysubcategorys',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name,inventorycategory,size_in} = action.payload;
      state.formData = { id, name,inventorycategory,size_in};
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        size_in: "",
        inventorycategory: "",
      };
    },
    setinventorysubcategory(state, action) {
      state.inventorysubcategory = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
 
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchinventorysubcategoryList.fulfilled, (state, action) => {
        state.inventorysubcategorylist = action.payload.data;
      })
      .addCase(fetchinventorysubcategoryList.rejected, (state, action) => {
        state.inventorysubcategorylist = [];
      })
     
       // Fetch inventorysubcategory
       .addCase(fetchinventorysubcategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchinventorysubcategory.fulfilled, (state, action) => {
        state.loading = false;
        state.inventorysubcategory = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchinventorysubcategory.rejected, (state, action) => {
        state.loading = false;
        state.inventorysubcategory = [];
        state.error = action.payload;
      })

      // Add inventorysubcategory
      .addCase(createinventorysubcategory.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createinventorysubcategory.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createinventorysubcategory.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage);  
        state.IsEditing = false;
      })
      // Update inventorysubcategory
      .addCase(updateinventorysubcategory.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateinventorysubcategory.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateinventorysubcategory.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action?.payload?.data?.message;
        state.IsEditing = false;
        const errorMessage = action?.payload?.data?.message || "Something went wrong!";
        toast.info(errorMessage); 
      })
      // Delete inventorysubcategory
      .addCase(deleteinventorysubcategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteinventorysubcategory.fulfilled, (state, action) => {
        state.loading = false;
        console.log(action.payload);
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteinventorysubcategory.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setinventorysubcategory,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setPageSize } = inventorysubcategorySlice.actions;
export default inventorysubcategorySlice.reducer;
